import { Pricing } from '../components/home/Pricing';

export default function Tarification() {
  return <Pricing />;
}
